import { trackEvent } from '@/omega/index';
export const jsApiErrorLogs = (result = {}) => {
  try {
    const { js_api = '', path = '', err_msg = '', user_agent = '' } = result;
    trackEvent({
      eventId: '',
      eventLabel: '闪送b2c_js异常监控',
      attrs: {
        js_api,
        path,
        err_msg,
        user_agent,
      },
    });
  } catch (err) {}
};
